<template>
  <div class="report-offers">
    <mainmenu selected="report_offers"></mainmenu>
    <div class="container-fluid report-offers-shell">
      <div class="report-offers-header">
        <div>
          <h1>{{$t('report_offers.page_title')}}</h1>
          <div class="report-offers-summary">
            {{$t('report_offers.available_offers')}} <strong>{{RowCount}}</strong>
          </div>
        </div>
        <a :href="$http.options.root + 'report_offers/export_excel'" target="_blank" class="el-button el-button--success">
          <i class="el-icon-download"></i>
          {{$t('report_offers.excel')}}
        </a>
      </div>

      <div class="report-offers-card">
        <div class="report-card-title">
          <div>
            <span>{{$t('report_offers.latest_offers')}}</span>
            <small>{{$t('report_offers.sorted_by_id')}}</small>
          </div>
          <span class="total-pill">{{$t('report_offers.total')}} {{PaginationInfo.RowCount}}</span>
        </div>
        <el-table
          class="report-offers-table"
          :data="Results"
          :height="tableHeight"
          stripe
          v-loading="loadingVisible"
          :empty-text="$t('report_offers.empty_results')">
          <el-table-column prop="Id" :label="$t('report_offers.offer_id')" width="80"></el-table-column>
          <el-table-column :label="$t('report_offers.created')" width="150">
            <template slot-scope="scope">{{formatDate(scope.row.FirstUploadDate)}}</template>
          </el-table-column>
          <el-table-column prop="FactoryCode" :label="$t('report_offers.factory')" width="110"></el-table-column>
          <el-table-column prop="SellerName" :label="$t('report_offers.seller')" width="190" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('report_offers.article_info')" min-width="360">
            <template slot-scope="scope">
              <div class="article-main"><strong>{{scope.row.ArticleNumber}}</strong> - {{scope.row.ProductName}}</div>
              <div class="article-category">{{scope.row.ProductCategory}}</div>
              <p class="article-description">{{scope.row.ProductDescription}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="Quantity" :label="$t('report_offers.quantity')" width="105" align="right"></el-table-column>
          <el-table-column :label="$t('report_offers.price')" width="105" align="right">
            <template slot-scope="scope">{{scope.row.Price|format_money}} &euro;</template>
          </el-table-column>
        </el-table>

        <div class="report-pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="refresh_info"
            :page-sizes="PaginationInfo.PageSizes"
            :page-size.sync="PaginationInfo.PerPage"
            :current-page.sync="PaginationInfo.Page"
            :total="PaginationInfo.RowCount"
            layout="total, sizes, prev, pager, next">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainMenu from "./../../widgets/MainMenu";
import settings from "./../../backend/LocalSettings";

export default {
  name: "report-offers",
  components: {
    "mainmenu": MainMenu
  },
  data() {
    return {
      loadingVisible: false,
      RowCount: 0,
      Results: [],
      tableHeight: 520,
      PaginationInfo: { Page: 1, PerPage: 10, RowCount: 0, PageSizes: [10, 25, 50, 100] }
    };
  },
  methods: {
    updateTableHeight: function() {
      var availableHeight = window.innerHeight - 470;
      this.tableHeight = Math.max(360, Math.min(availableHeight, 620));
    },
    formatDate: function(value) {
      if(!value || value === "0000-00-00 00:00:00") return "-";
      var parts = String(value).split(/[- :]/);
      if(parts.length < 5) return value;
      var dateValue = new Date(Date.UTC(
        Number(parts[0]),
        Number(parts[1]) - 1,
        Number(parts[2]),
        Number(parts[3] || 0),
        Number(parts[4] || 0),
        Number(parts[5] || 0)
      ));
      if(isNaN(dateValue.getTime())) return value;
      var pad = function(part) { return String(part).padStart(2, "0"); };
      return pad(dateValue.getDate()) + "." + pad(dateValue.getMonth() + 1) + "." + dateValue.getFullYear() + " " + pad(dateValue.getHours()) + ":" + pad(dateValue.getMinutes());
    },
    handleSizeChange: function() {
      this.PaginationInfo.Page = 1;
      this.refresh_info();
    },
    refresh_info: function() {
      this.loadingVisible = true;
      this.$http
        .post('report_offers/refresh_info', { PaginationInfo: this.PaginationInfo })
        .then(function(response) {
          this.loadingVisible = false;
          if(settings.verify_response(response, this.$rights)) {
            this.Results = response.body.Results;
            this.PaginationInfo = response.body.PaginationInfo;
            this.RowCount = this.PaginationInfo.RowCount;
          } else {
            this.$router.push("/");
          }
        })
        .catch(function() {
          this.loadingVisible = false;
          this.$message.error("Could not load offers report.");
        });
    }
  },
  mounted: function() {
    this.updateTableHeight();
    window.addEventListener("resize", this.updateTableHeight);
    this.refresh_info();
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.updateTableHeight);
  }
};
</script>

<style lang="less" scoped>
.report-offers-shell {
  padding: 14px 10px 28px;
}

.report-offers-header,
.report-offers-card {
  border: 1px solid rgba(26, 88, 111, 0.12);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 12px 26px rgba(25, 80, 99, 0.13);
}

.report-offers-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 14px;
  padding: 18px;

  h1 {
    margin: 0;
    color: #152b38;
    font-size: 31px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 36px;
  }
}

.report-offers-summary {
  margin-top: 2px;
  color: rgba(21, 43, 56, 0.72);
  font-size: 13px;
  font-weight: 600;
}

.report-offers-card {
  overflow: hidden;
}

.report-card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 13px 18px;
  border-bottom: 1px solid #e6edf2;
  background: #fbfdfe;
  color: #223947;
  font-size: 15px;
  font-weight: 800;

  small {
    display: block;
    margin-top: 2px;
    color: #6b7c87;
    font-size: 12px;
    font-weight: 700;
  }
}

.total-pill {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0 10px;
  border-radius: 4px;
  background: #eef6f9;
  color: #2b6275;
  font-size: 12px;
  font-weight: 800;
}

.report-offers-table /deep/ th {
  padding: 10px 0;
  background: #f4f8fa;
  color: #526875;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
}

.report-offers-table /deep/ td {
  padding: 7px 0;
  border-bottom-color: #e7edf2;
  color: #405461;
}

.article-main {
  color: #314754;
  line-height: 19px;
}

.article-category {
  margin-top: 2px;
  color: #526976;
  font-style: italic;
  line-height: 18px;
}

.article-description {
  margin: 4px 0 0;
  color: #64727c;
  font-size: 12px;
  line-height: 17px;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  min-width: 48px;
  justify-content: center;
  padding: 2px 7px;
  border-radius: 4px;
  background: #eef4f8;
  color: #426274;
  font-size: 11px;
  font-weight: 700;
}

.report-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 12px 18px;
  border-top: 1px solid #e6edf2;
  background: #fbfdfe;
}

@media (max-width: 760px) {
  .report-offers-header {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
